import { useEffect } from "react";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Box, Flex } from "@chakra-ui/react";

import ClientSidebar from "../../components/ClientSidebar/ClientLeftSidebar";
import Header from "../../shared/Header/Header";
import "./ClientLayout.scss";
import { getClientDetails } from "../../actions/client/clientActions";
import LeftSideNav from "../../shared/LeftSideNav/LeftSideNav";

const ClientLayout = () => {
  const { clientId } = useParams();
  const dispatch = useDispatch();
  const { isAuthenticatedUser } = useSelector((state) => state.userReducer);

  useEffect(() => {
    if (clientId) {
      dispatch(getClientDetails(clientId));
    }
  }, [clientId]);

  return (
    <>
      <Box w="100%" bg="var(--body-bg)">
        <Box>
          <Header />
        </Box>

        <Flex style={{ backgroundColor: "var(--sylvr-bg-color)" }}>
          {isAuthenticatedUser ? <ClientSidebar /> : <LeftSideNav />}

          <Box
            w="100%"
            h="calc(100% - var(--headerbar-height) - var(--footerbar-height))"
          >
            <Outlet />
          </Box>
        </Flex>
      </Box>
    </>
  );
};

export default ClientLayout;
